import {
  Label,
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Container,
} from "reactstrap";
import DateTimePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useState, useCallback, useEffect } from "react";
import { usePagination } from "../../hooks/usePagination";
import Table from "../table/Table";
import ApiService from "../../services/apiService";
import RightIcon from "../svg/RightIcon";
import LeftIcon from "../svg/LeftButton";
import { format } from "date-fns";
import { useMemo } from "react";
import { method } from "lodash";
import { styleText } from "util";
import { color } from "highcharts";
import { useNavigate } from "react-router-dom";
import CommonCardHeader from "../../coreComponents/CommonCardHeader";
import Breadcrumbs from "../../coreComponents/breadcrumbs";
import ExportExcel from "./ExportExcel";
import { toast } from "react-toastify";

const Report = () => {
  // calling report api
  const [isAction, setIsAction] = useState<boolean>();
  const [fromDateTime, setFromDateTime] = useState(null);
  const [toDateTime, setToDateTime] = useState(null);
  const [chakData, setChakData] = useState<any | []>([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [secondDropdownOpen, setSecondDropdownOpen] = useState<boolean>(false);
  const [selectedApi, setSelectedApi] = useState<string | null>("chakhistory");
  const [isEnabled, setIsEnabled] = useState(false);
  const [selectedChakName, setSelectedChakName] = useState("");
  const [refreshKey, setRefreshKey] = useState(0);
  const [pumpingStationHistory, setPumpingStationHistory] = useState<any>();
  const navigate = useNavigate();
  let updatedData: any = [];

  const toggleDropdown = () => setDropdownOpen((prev) => !prev);
  const toggleSecondDropdown = () => setSecondDropdownOpen((prev) => !prev);
  useEffect(() => {
    const getChak = async () => {
      try {
        const response = await ApiService.axiosApi(`/chack`, {
          method: "GET",
          params: {
            pageNumber: 0,
            pageSize: 0,
          },
        });
        if (response.success) {
          setChakData(response.data.data);
        } else {
          console.log(
            response.message || response.status || "unable to get chak "
          );
        }
      } catch (error) {
        console.log(error);
      }
    };

    getChak();
  }, []);

  function formatDate(dateString: any) {
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0");
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${day}-${month}-${year} ${hours}:${minutes}`;
  }

  const {
    data,
    pageNumber,
    setPageNumber,
    pageSize,
    totalCount,
    setRefresh,
    setFromDate,
    setToDate,
    setId,
    id,
    setData,
    fromDate,
    toDate,
  } = usePagination({
    endpoint: `/${selectedApi}`,
    refreshKey,
    enabled: isEnabled,
  });

  updatedData = useMemo(() => {
    if (!data || !Array.isArray(data)) return [];

    return data.map((time) => {
      if (selectedApi === "alarms/history") {
        return {
          ...time,
          alarmTime: time.alarmTime
            ? format(new Date(time.alarmTime), "dd-MM-yyyy HH:mm:ss")
            : "-",
          acknowledgeTime: time.acknowledgeTime
            ? format(new Date(time.acknowledgeTime), "dd-MM-yyyy HH:mm:ss")
            : "-",
          offTime: time.offTime
            ? format(new Date(time.offTime), "dd-MM-yyyy HH:mm:ss")
            : "-",
        };
      } else if (selectedApi === "chakhistory") {
        return {
          ...time,
          dateTime: time.dateTime
            ? format(new Date(time.dateTime), "dd-MM-yyyy HH:mm:ss")
            : "-",
        };
      } else if (selectedApi === "pumpingstation/history") {
        return {
          ...time,
          dateTime: time.dateTime
            ? format(new Date(time.dateTime), "dd-MM-yyyy HH:mm:ss")
            : "-",
        };
      }
      return time;
    });
  }, [data, selectedApi, refreshKey]);

  /*if(data){
   setChakHistory('')
}*/

  const totalPages = Math.ceil(totalCount / pageSize);

  const handleNext = useCallback(() => {
    setPageNumber((prev) => Math.min(totalPages, prev + 1));
  }, [setPageNumber, totalPages]);

  const handlePrev = useCallback(() => {
    setPageNumber((prev) => Math.max(1, prev - 1));
  }, [setPageNumber, totalPages]);

  const handleClick = () => {
    
    if (!validateGenerate()) return;

    if (fromDateTime) {
      setFromDate(formatDate(fromDateTime));
    }
    if (toDateTime) {
      setToDate(formatDate(toDateTime));
    }
    setIsEnabled(true); // Enable only once
    setRefreshKey((prev) => prev + 1); // Force API re-fetch
    setPageNumber(1);
  };

  const handleAddStation = () => {
    navigate(`/pumping-history-add`);
  };

  const handleUpdateStation = (id: any) => {
    navigate(`/pumping-history-update/${id}`);
  };
  useEffect(() => {
    setData([]);

    setFromDateTime(null);
    setToDateTime(null);

    setRefreshKey((prev) => prev + 1); // trigger new fetch

    if (
      selectedApi === "pumpingstation/history" ||
      selectedApi === "alarms/history"
    ) {
      setSelectedChakName("");
      setId(null);
    }
  }, [selectedApi]);

  if (updatedData != null || undefined) {
    console.log(updatedData);
  }
  const fetchAllDataForExport = async () => {
    try {
      const response = await ApiService.axiosApi(`/${selectedApi}`, {
        method: "GET",
        params: {
          pageNumber: 0,
          pageSize: 0,
          chakId: id, // selected Chak ID
          fromDate: fromDate,
          toDate: toDate,
          // <-- fetch ALL rows
        },
      });

      if (response.success) {
        return response.data.data.map((time:any) => {
          if (selectedApi === "alarms/history") {
            return {
              ...time,
              alarmTime: time.alarmTime
                ? format(new Date(time.alarmTime), "dd-MM-yyyy HH:mm:ss")
                : "-",
              acknowledgeTime: time.acknowledgeTime
                ? format(new Date(time.acknowledgeTime), "dd-MM-yyyy HH:mm:ss")
                : "-",
              offTime: time.offTime
                ? format(new Date(time.offTime), "dd-MM-yyyy HH:mm:ss")
                : "-",
            };
          } else if (selectedApi === "chakhistory") {
            return {
              ...time,
              dateTime: time.dateTime
                ? format(new Date(time.dateTime), "dd-MM-yyyy HH:mm:ss")
                : "-",
            };
          } else if (selectedApi === "pumpingstation/history") {
            return {
              ...time,
              dateTime: time.dateTime
                ? format(new Date(time.dateTime), "dd-MM-yyyy HH:mm:ss")
                : "-",
            };
          }
          return time;
        })
      } else {
        toast.error("Unable to fetch full report");
        return [];
      }
    } catch (error) {
      console.log(error);
      toast.error("API Error");
      return [];
    }
  };

  const validateGenerate = () => {
    if (!selectedApi) {
      toast.warning("Please select Report Type");
      return false;
    }

    if (selectedApi !== "pumpingstation/history" && !id) {
      toast.warning("Please select Chak");
      return false;
    }

    if (!fromDateTime) {
      toast.warning("Please select From Date");
      return false;
    }

    if (!toDateTime) {
      toast.warning("Please select To Date");
      return false;
    }

    if (new Date(fromDateTime) > new Date(toDateTime)) {
      toast.warning("From Date cannot be greater than To Date");
      return false;
    }

    return true;
  };

  return (
    <>
      <Breadcrumbs mainTitle={"Reports"} parent={"report"} />
      <div className="report px-2 py-2">
        <div className="report-header d-flex justify-content-between align-items-center bg-light-primary">
          <div className="d-flex py-2 justify-content-evenly align-items-center report-dropdowndatetime">
            <div className="mx-4 pb-2 input-border d-flex flex-row align-content-center items-center gap-4 report-dropdown-wrapper">
              {/* First Dropdown Group */}
              <div className="d-flex flex-column"
                style={{width:"100%"}}
              >
                <Label> Report Type:</Label>
                <Dropdown
                  isOpen={secondDropdownOpen}
                  toggle={toggleSecondDropdown}
                  className="report-dropdown-one"
                >
                  <DropdownToggle
                    className="custom-dropdown-toggle d-flex align-items-center justify-content-between "
                    style={{
                      backgroundColor: "#007bff",
                      borderColor: "#007bff",
                      color: "#fff",
                      fontWeight: 500,
                      borderRadius: "5px",
                      padding: "8px 16px",
                      width:'100%',
                      height: "36px",
                    }}
                    color="primary"
                  >
                    {selectedApi == "chakhistory"
                      ? "Chak"
                      : selectedApi == "alarms/history"
                      ? "Alarm"
                      : "Pumping Station"}
                  </DropdownToggle> 
                  <DropdownMenu
                    className="custom-dropdown-menu"
                    style={{
                      overflowY: "auto",
                      boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.1)",
                      borderRadius: "8px",
                      padding: "8px 0",
                      width:'100%',
                    }}
                  >
                    <DropdownItem
                      onClick={() => {
                        setSelectedApi("chakhistory");
                      }}
                    >
                      Chak
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => setSelectedApi("alarms/history")}
                    >
                      Alarm
                    </DropdownItem>
                   
                  </DropdownMenu>
                </Dropdown>
              </div>

              {/* Second Dropdown Group */}
              {selectedApi === "pumpingstation/history" ? (
                ""
              ) : (
                <div className="d-flex flex-column"style={{width:"100%"}}>
                  <Label>Chak Name:</Label>
                  <Dropdown
                    isOpen={dropdownOpen}
                    toggle={toggleDropdown}
                    className="report-dropdown-two"
                  >
                    <DropdownToggle
                      className="custom-dropdown-toggle d-flex align-items-center justify-content-between "
                      style={{
                        backgroundColor: "#007bff",
                        borderColor: "#007bff",
                        color: "#fff",
                        fontWeight: 500,
                        borderRadius: "5px",
                        padding: "8px 16px",
                        height: "36px",
                        width:'100%',
                      }}
                      color="primary"
                    >
                      {selectedChakName ? selectedChakName : "Select chak"}
                    </DropdownToggle>
                    <DropdownMenu
                      className="custom-dropdown-menu"
                      style={{
                        boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.1)",
                        borderRadius: "8px",
                        padding: "8px 0",
                        width:'100%'
                      }}
                    >
                      {chakData.map((data: any) => (
                        <DropdownItem
                          onClick={() => {
                            setId(data.id);
                            setSelectedChakName(data.chackName);
                          }}
                          key={data.id}
                        >
                          {data.chackName}
                        </DropdownItem>
                      ))}
                    </DropdownMenu>
                  </Dropdown>
                </div>
              )}
            </div>

            <div className="report-fromtodate-wrapper d-flex">
            <div className="mx-4 input-border pb-2 d-flex flex-column "style={{width:'50%'}}>
              <Label>From Date:</Label>
              <DateTimePicker
                className="report-input-one"
                dateFormat="dd/MM/yyyy HH:mm:ss"
                placeholderText="DD-MM-YYYY"
                showTimeSelect
                onChange={(date: any) => setFromDateTime(date)}
                selected={fromDateTime}
                isClearable
                timeFormat="HH:mm:ss"
              />
            </div>
            <div className="mx-4  input-border pb-2 d-flex flex-column "style={{width:'50%'}}>
              <Label>To Date:</Label>
              <DateTimePicker
                className="report-input-two"
                dateFormat="dd/MM/yyyy HH:mm:ss"
                placeholderText="DD-MM-YYYY"
                showTimeSelect
                onChange={(date: any) => setToDateTime(date)}
                selected={toDateTime}
                isClearable
                timeFormat="HH:mm:ss"
              />
            </div>
            </div>
          </div>

          <div className="d-flex  buttonclass-report gap-4">
            <div  style={{width:'40%'}}>
            <Label style={{ visibility: "hidden" }}>Generate</Label>
            <Button
              className="me-3 px-0"
              
              color="success"
              onClick={handleClick}
              style={{width:'100%'}}
            >
              Generate
            </Button>
            </div>
            <ExportExcel
              getData={fetchAllDataForExport}
              fileName={
                selectedApi === "chakhistory" ? "Chak_History" : "Alarm_History"
              }
              columnStyle={
                selectedApi === "chakhistory"
                  ? {
                      0: { cellWidth: 40, halign: "center" },
                      1: { cellWidth: 40, halign: "center" },
                      2: { cellWidth: 30, halign: "center" },
                      3: { cellWidth: 30, halign: "center" },
                      4: { cellWidth: 30, halign: "center" },
                      5: { cellWidth: 40, halign: "center" },
                      6: { cellWidth: 60, halign: "center" },
                      7: { cellWidth: 40, halign: "center" },
                      8: { cellWidth: 40, halign: "center" },
                      9: { cellWidth: 50, halign: "center" },
                      10: { cellWidth: 50, halign: "center" },
                      11: { cellWidth: 50, halign: "center" },
                      12: { cellWidth: 50, halign: "center" },
                      13: { cellWidth: 20, halign: "center" },
                      14: { cellWidth: 20, halign: "center" },
                      15: { cellWidth: 20, halign: "center" },
                      16: { cellWidth: 20, halign: "center" },
                      17: { cellWidth: 20, halign: "center" },
                      18: { cellWidth: 20, halign: "center" },
                      19: { cellWidth: 20, halign: "center" },
                      20: { cellWidth: 20, halign: "center" },
                      21: { cellWidth: 20, halign: "center" },
                      22: { cellWidth: 20, halign: "center" },
                      23: { cellWidth: 20, halign: "center" },
                      24: { cellWidth: 20, halign: "center" },
                      25: { cellWidth: 20, halign: "center" },
                      26: { cellWidth: 20, halign: "center" },
                    }
                  : undefined
              }
              EffectiveFrom={fromDate}
              toDate={toDate}
              style={{
                 width:'40%'
              }}
              selectedChakScheme={selectedChakName}
              hiddenColumns={['door2']}
            />
          </div>
        </div>

        <Table
          isAction={selectedApi === "pumpingstation/history" ? true : false}
          data={updatedData}
          columns={
            selectedApi == "chakhistory"
              ? [
                  { header: "Duid", accessor: "duid" },
                  { header: "DateTime", accessor: "dateTime" },
                  { header: "Battery(%)", accessor: "battery" },
                  { header: "Door1", accessor: "door1" },
                 
                  { header: "FlowRate", accessor: "flowRate" },
                  { header: "NetworkStatus", accessor: "networkStatus" },
                  { header: "TodayVolume", accessor: "todayVolume" },
                  { header: "Pressure", accessor: "pressure" },
                  { header: "RomsAuto", accessor: "romsAuto" },
                  { header: "SolarVoltage", accessor: "solarVoltage" },
                  { header: "Temperature(°C)", accessor: "temprature" },
                 
                  { header: "V1", accessor: "v1" },
                  { header: "V2", accessor: "v2" },
                  { header: "V3", accessor: "v3" },
                  { header: "V4", accessor: "v4" },
                  { header: "V5", accessor: "v5" },
                  { header: "V6", accessor: "v6" },
                  { header: "V7", accessor: "v7" },
                  { header: "V8", accessor: "v8" },
                  { header: "V9", accessor: "v9" },
                  { header: "V10", accessor: "v10" },
                  { header: "V11", accessor: "v11" },
                  { header: "V12", accessor: "v12" },
                  { header: "V13", accessor: "v13" },
                  { header: "V14", accessor: "v14" },
                ]
              : selectedApi == "alarms/history"
              ? [
                  { header: "Chak Name", accessor: "chakName" },
                  { header: "Distrbutary/Zone", accessor: "distributaryZone" },
                  { header: "Scheme/Village", accessor: "schemeVillage" },
                  {
                    header: "No. On/Of Valves",
                    accessor: "no_Of_On_Of_Valves",
                  },
                  { header: "Alarm Time", accessor: "alarmTime" },
                  { header: "Alarm", accessor: "alarm" },
                  { header: "Alarm OffTime", accessor: "offTime" },
                  { header: "Acknowledge By", accessor: "userName" },
                  {
                    header: "Acknowledge Remark",
                    accessor: "acknowledgeRemark",
                  },
                  { header: "Acknowledge Time", accessor: "acknowledgeTime" },
                ]
              : selectedApi == "pumpingstation/history"
              ? [
                  { header: "Pump Number", accessor: "pumpNumber" },
                  { header: "Daily Volume", accessor: "dailyVolume" },
                  { header: "DateTime", accessor: "dateTime" },
                ]
              : [{}]
          }
          buttons={
            selectedApi === "pumpingstation/history"
              ? [
                  {
                    label: "Add",
                    onClick: handleAddStation,
                    color: "primary",
                    className: "me-2",
                  },
                  {
                    label: "Edit",
                    onClick: handleUpdateStation,
                    color: "primary",
                  },
                ]
              : []
          }
        />
        <div
          className=" d-flex justify-content-end align-content-center"
          style={{ marginRight: "10px", marginTop: "10px" }}
        >
          <p style={{ marginRight: "10px", marginTop: "8px" }}>
            Page {pageNumber} of {totalPages}
          </p>
          <button
            onClick={handlePrev}
            disabled={pageNumber === 1}
            className={`icon-button ${
              pageNumber === totalPages ? `icon-button` : ""
            }`}
          >
            <LeftIcon className="icon" />
          </button>
          <button
            className={`icon-button ${
              pageNumber === totalPages ? "disabled" : ""
            }`}
            onClick={handleNext}
            disabled={pageNumber === totalPages}
          >
            <RightIcon className="icon" />
          </button>
        </div>
      </div>
    </>
  );
};

export default Report;
